import { theme } from "@theme";
import React from "react";
import type { AccessibilityRole, AccessibilityState } from "react-native";
import LBox from "./LBox";
import LButton from "./LButton";
import { IconName } from "./LIcon";

export const defaults = {
  selectedGradient: [
    "buttonBackgroundPrimaryLeft",
    "buttonBackgroundPrimaryRight",
  ] as Array<keyof typeof theme.colors>,
};

const CapsuleButton = ({
  isSelected,
  onPress,
  title,
  iconName,
  iconSize,
  iconMargin,
  selectedGradient,
  sentryEventName,
  accessibilityHint,
  accessibilityLabel,
  accessibilityRole = "button",
  accessibilityState,
}: {
  isSelected: boolean;
  onPress?: () => void;
  title: string;
  iconName?: IconName;
  iconSize?: number;
  iconMargin?: keyof typeof theme.spacing;
  selectedGradient?: Array<keyof typeof theme.colors>;
  sentryEventName?: string;
  accessibilityHint?: string;
  accessibilityLabel?: string;
  accessibilityRole?: AccessibilityRole;
  accessibilityState?: AccessibilityState;
}) => {
  return (
    <LBox
      borderRadius="max"
      gradientDirection="horizontal"
      backgroundColor={isSelected ? selectedGradient ?? "white" : undefined}
    >
      <LButton
        sentryEventName={sentryEventName || ""}
        variant={isSelected ? "capsuleFilled" : "capsule"}
        label={title}
        textVariant={isSelected ? "capsuleFilled" : "bodyM"}
        onPress={onPress || (() => {})}
        iconName={iconName}
        iconSize={iconSize}
        iconMargin={iconMargin}
        accessibilityHint={accessibilityHint}
        accessibilityLabel={accessibilityLabel}
        accessibilityRole={accessibilityRole}
        accessibilityState={accessibilityState}
      />
    </LBox>
  );
};

export default CapsuleButton;
